export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isFunction = (x: Function) => typeof x === "function";
  const isString = (x: string) => typeof x === "string";
  const validateDate = (date: any): boolean => {
    return (
      date.hasOwnProperty("day") &&
      date.hasOwnProperty("month") &&
      date.hasOwnProperty("year")
    );
  };

  const methods = {
    disabled: isBoolean,
    disableItems: isFunction,
    formControlName: isString,
    id: isString,
    isShowAdjacentValues: isBoolean,
    max: validateDate,
    min: validateDate
  };

  return methods[key] && methods[key](value);
};
